<div class="pm-v2-page">
  <div class="card card-statistics mb-30">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-8">
          <h4 class="mb-0">جزئیات تخصیص PM V2</h4>
        </div>
        <div class="col-sm-4 text-left">
          <button type="button" style="margin-left: 5px;" class="btn btn-warning ml-2" (click)="Back()">بازگشت</button>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="Procssing" class="pm-v2-empty">در حال دریافت اطلاعات...</div>

  <ng-container *ngIf="!Procssing && Model">
    <div class="card card-statistics mb-30">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3"><strong>کد تجهیز:</strong> {{ Model.codeBEHFA }}</div>
          <div class="col-md-3"><strong>شرح:</strong> {{ Model.description }}</div>
          <div class="col-md-4"><strong>PM:</strong> {{ Model.PM_Code }} - {{ Model.PM_Title }}</div>
          <div class="col-md-2"><strong>Version:</strong> {{ Model.Version }}</div>
        </div>
      </div>
    </div>

    <div class="card card-statistics mb-30">
      <div class="card-header"><strong>آیتم‌ها و برنامه زمانی تجهیز</strong></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>ترتیب</th>
                <th>فعالیت</th>
                <th>دوره</th>
                <th>هشدار</th>
                <th>شروع</th>
                <th>آخرین PM</th>
                <th>PM بعدی</th>
                <th>وضعیت</th>
                <th>فعال</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Items">
                <td>{{ item.Order_Item }}</td>
                <td>{{ item.Title_Item }}</td>
                <td>{{ item.Value_Frequency }} روز</td>
                <td>{{ item.Days_Warning }} روز</td>
                <td>{{ item.Date_Start | date:'yyyy/MM/dd' }}</td>
                <td>{{ item.Last_PM_Date ? (item.Last_PM_Date | date:'yyyy/MM/dd') : '-' }}</td>
                <td>{{ item.Next_PM_Date ? (item.Next_PM_Date | date:'yyyy/MM/dd') : '-' }}</td>
                <td>
                  <p class="badge" [ngClass]="StatusClass(item.PM_Status)">
                    {{ StatusTitle(item.PM_Status) }}
                  </p>
                </td>
                <td>
                  <p *ngIf="item.Active" style="color: #489b39;">فعال</p>
                  <p *ngIf="!item.Active" style="color: crimson;">غیر فعال</p>
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown">امکانات</button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" style="cursor:pointer" (click)="Execute(item)"><i
                          class="fa fa-plus-circle"></i> اجراء خارج از برنامه</a>
                      <a class="dropdown-item" style="cursor:pointer" (click)="History(item)"><i class="fa fa-list"></i>
                        تاریخچه</a>
                      <a *ngIf="item.Active==true" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                      <a *ngIf="item.Active==false" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>
                    </div>
                  </div>
                </td>
              </tr>

              <tr *ngIf="Items.length === 0">
                <td colspan="10" class="text-center">آیتمی وجود ندارد.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-container>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.Active==true" class="modal-title pull-left">تایید غیرفعال اطلاعات
      '{{Data_Seleted_Delete.Title_Item}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.Active==false" class="modal-title pull-left">تایید فعال اطلاعات
      '{{Data_Seleted_Delete.Title_Item}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.Active==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> غیرفعال اطلاعات <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.Active==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> فعال اطلاعات <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>